import Skeleton from 'react-loading-skeleton';

const PreferencesFormSkeleton = ({ skeletonClassName, skeletonCount }) => {
  return (
    <div className="mx-auto w-full max-w-xl p-10">
      <section className={`rounded-md ${skeletonClassName}`}>
        <Skeleton count={skeletonCount} className="my-6" height={32} />
      </section>
    </div>
  );
};

PreferencesFormSkeleton.propTypes = {
  skeletonCount: PropTypes.number,
  skeletonClassName: PropTypes.string,
};

export default PreferencesFormSkeleton;
